import PropTypes from "prop-types"

import _ from "lodash"

import React, { useState, useEffect } from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams } from "react-router-dom"

import withRouter from "components/Common/withRouter"

import { getSession, setSession, getCurrentUser } from "helpers/AuthType/authService"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"


// import { updateAddress } from "helpers/Digital/digitalService"

const LandingPage = props => {
  //meta title
  document.title = "Applicant Information | Equity Sales Finance, INC."

  const dispatch = useDispatch()

  let { merchant : {name}} = getSession(),
  applicantType = props.state.applicantType,applicant;

  if(applicantType == 'coapplicant')
  ({_applicant : applicant} = getCurrentUser());
  
  const start = event => {
    props.router.navigate(applicantType== "coapplicant" ? "/co/personal-information" : "/personal-information")
  }

  return (
    <React.Fragment>      

      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="16" className="text-bg-warning p-3">
              <Card className="text-bg-warning p-3">
                <CardBody>
                  <CardTitle className="mb-4 text-center"><h1 className="display-3 text-center text-dark">{_.toUpper(name)}</h1></CardTitle>
                  <h2 className="card-title mb-4 text-center text-dark font-size-20">Welcome to our financing application.</h2>  
                  
                  {applicantType== "coapplicant" && (
                    <h2 className="card-title mb-4 text-center text-dark font-size-16">{`Co-Signing application for ${applicant}`}</h2> 
                  )}
                  
                  <h2 className="card-title mb-4 text-center text-dark font-size-16">{`Click on the "Get Started" button to begin filling out your application`}</h2> 

                  <div className="text-center">
                    <Button 
                      color="primary" 
                      className="btn btn-primary w-lg"
                      onClick={e => {
                        e.preventDefault()
                        start()
                      }}
                    >
                      {_.toUpper("Get Started")}
                    </Button>
                  </div> 
                    {/* <div className="d-grid gap-2">
                      <Button color="primary" type="button" className="btn-lg">{_.toUpper("Get Started")}</Button>
                    </div>                */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(LandingPage)

LandingPage.propTypes = {
  history: PropTypes.object,
}
